import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SearchBarDoctorComponent } from './subscriber/search-bar-doctor/search-bar-doctor.component';



@NgModule({
    imports: [
        IonicModule
    ],
    declarations: [/*SearchBarDoctorComponent*/],
exports:[/*SearchBarDoctorComponent*/]
})
export class CustomSearchModule {}
